import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

// Define the icon mapping interface
interface IconMapping {
  key: string;
  imagePath: string;
}

@Component({
    selector: 'app-add-category-dialog',
    templateUrl: './add-category-dialog.component.html',
    styleUrls: ['./add-category-dialog.component.css'],
    standalone: false
})
export class AddCategoryDialogComponent implements OnInit {
  categoryName: string = '';
  selectedIconIndex: number = 0; // Set first icon as default
  
  // Icon mappings with keys that match Android/iOS
  iconMappings: IconMapping[] = [
    { key: 'file_folder', imagePath: 'assets/file_folder.png' },
    { key: 'building-office', imagePath: 'assets/building-office.png' },
    { key: 'carbon_finance', imagePath: 'assets/carbon_finance.png' },
    { key: 'fluent-mdl2_education', imagePath: 'assets/fluent-mdl2_education.png' },
    { key: 'healthicons_ui-folder-family-outline', imagePath: 'assets/healthicons_ui-folder-family-outline.png' },
    { key: 'hugeicons_invoice-02', imagePath: 'assets/hugeicons_invoice-02.png' },
    { key: 'Folder-lock', imagePath: 'assets/Folder-lock.png' },
    { key: 'Book-mark', imagePath: 'assets/Book-mark.png' },
    { key: 'Book-open', imagePath: 'assets/Book-open.png' },
    { key: 'capsule', imagePath: 'assets/capsule.png' },
    { key: 'target', imagePath: 'assets/target.png' },
    { key: 'download_3', imagePath: 'assets/download_3.png' },
    { key: 'ep_goods', imagePath: 'assets/ep_goods.png' },
    { key: 'flight_takeoff', imagePath: 'assets/flight_takeoff.png' },
    { key: 'fluent_mail-24-regular', imagePath: 'assets/fluent_mail-24-regular.png' },
    { key: 'hugeicons_analytics-up', imagePath: 'assets/hugeicons_analytics-up.png' },
    { key: 'leaf', imagePath: 'assets/leaf.png' },
    { key: 'lets-icons_shop-light', imagePath: 'assets/lets-icons_shop-light.png' },
    { key: 'location', imagePath: 'assets/location.png' },
    { key: 'lucide_briefcase-business', imagePath: 'assets/lucide_briefcase-business.png' },
    { key: 'ph_certificate-light', imagePath: 'assets/ph_certificate-light.png' },
    { key: 'stack', imagePath: 'assets/Stack.png' }, // Note: capital S in filename
    { key: 'streamline_business-user-curriculum', imagePath: 'assets/streamline_business-user-curriculum.png' },
    { key: 'streamline_group-meeting-call', imagePath: 'assets/streamline_group-meeting-call.png' },
  ];

  constructor(
    public dialogRef: MatDialogRef<AddCategoryDialogComponent>, 
    private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log('data', this.data);

    if (this.data?.category) {
      // Editing mode
      this.categoryName = this.data.category.title || this.data.category.name;
      
      // Find the icon by key
      const iconIndex = this.iconMappings.findIndex(mapping => 
        mapping.key === this.data.category.icon || 
        mapping.imagePath === this.data.category.icon
      );
      
      this.selectedIconIndex = iconIndex >= 0 ? iconIndex : 0;
    } else {
      // Adding mode - default to first icon
      this.selectedIconIndex = 0;
    }
  }

  selectIcon(index: number): void {
    this.selectedIconIndex = index;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.data.existingCategories.length >= 10 && !this.data.category) {
      this.toast.error('Only 10 categories are allowed');
      return;
    }
    
    console.log('categoryName', this.categoryName);
    
    if (this.categoryName && this.selectedIconIndex !== null) {
      const selectedMapping = this.iconMappings[this.selectedIconIndex];

      const payload = {
        categoryName: this.categoryName,
        icon: selectedMapping.key // ✅ Send the key instead of image path
      };

      this.dialogRef.close(payload);
    }
  }

  // Helper method to get image path for display
  getSelectedIconPath(): string {
    if (this.selectedIconIndex >= 0 && this.selectedIconIndex < this.iconMappings.length) {
      return this.iconMappings[this.selectedIconIndex]?.imagePath || '';
    }
    return this.iconMappings[0]?.imagePath || '';
  }

  // Helper method to get all image paths for template
  getIconPaths(): string[] {
    return this.iconMappings.map(mapping => mapping.imagePath);
  }

  get headerIcon(): string {
    if (this.data?.category && this.data.category.icon) {
      // Editing mode → find the image path for the key
      const mapping = this.iconMappings.find(m => m.key === this.data.category.icon);
      return mapping ? mapping.imagePath : this.iconMappings[0]?.imagePath || '';
    }
    // Creation mode → default first icon
    return this.iconMappings[0]?.imagePath || '';
  }

  preventLeadingSpace(event: any) {
    if (!this.categoryName || this.categoryName.length === 0) {
      event.preventDefault();
    }
  }
}